import { useState } from 'react';
import { useNotifications } from '../../hooks/useNotifications';

export function NotificationBell() {
  const { notifications, unreadCount, markAsRead, markAllRead, clearAll } = useNotifications();
  const [open, setOpen] = useState(false);

  const handleBellClick = () => {
    setOpen(!open);
    if (!open && unreadCount > 0) {
      // 展开时自动标记可见通知为已读
      notifications.filter(n => !n.is_read).slice(0, 5).forEach(n => markAsRead(n.id));
    }
  };

  const typeIcon = (type: string) => {
    switch (type) {
      case 'NEW_BOOK': return '📚';
      case 'READING_REMINDER': return '⏰';
      case 'SYSTEM': return '🔔';
      default: return '📢';
    }
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        onClick={handleBellClick}
        style={{
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          padding: '8px',
          position: 'relative',
          color: '#fff',
          fontSize: '20px',
        }}
      >
        🔔
        {unreadCount > 0 && (
          <span style={{
            position: 'absolute',
            top: '2px',
            right: '2px',
            background: '#ff6b6b',
            color: '#fff',
            fontSize: '10px',
            fontWeight: 700,
            minWidth: '16px',
            height: '16px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0 4px',
          }}>
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </button>

      {open && (
        <>
          <div
            style={{
              position: 'fixed',
              inset: 0,
              zIndex: 998,
            }}
            onClick={() => setOpen(false)}
          />
          <div style={{
            position: 'absolute',
            top: 'calc(100% + 8px)',
            right: '0',
            width: '320px',
            maxHeight: '400px',
            background: 'linear-gradient(180deg, #1a2244, #161d3d)',
            border: '1px solid rgba(255,255,255,0.09)',
            borderRadius: '14px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
            zIndex: 999,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}>
            {/* Header */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '12px 16px',
              borderBottom: '1px solid rgba(255,255,255,0.06)',
            }}>
              <span style={{ fontSize: '14px', fontWeight: 700, color: '#ffd678' }}>
                通知 ({unreadCount} 未读)
              </span>
              <div style={{ display: 'flex', gap: '8px' }}>
                {unreadCount > 0 && (
                  <button
                    onClick={markAllRead}
                    style={{
                      background: 'none',
                      border: 'none',
                      color: '#7fb5ff',
                      fontSize: '12px',
                      cursor: 'pointer',
                      padding: '2px 4px',
                    }}
                  >
                    全部已读
                  </button>
                )}
                <button
                  onClick={clearAll}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: 'rgba(255,255,255,0.4)',
                    fontSize: '12px',
                    cursor: 'pointer',
                    padding: '2px 4px',
                  }}
                >
                  清除
                </button>
              </div>
            </div>

            {/* List */}
            <div style={{ overflowY: 'auto', flex: 1, padding: '4px' }}>
              {notifications.length === 0 ? (
                <div style={{
                  textAlign: 'center',
                  padding: '40px 20px',
                  color: 'rgba(255,255,255,0.3)',
                  fontSize: '13px',
                }}>
                  暂无通知
                </div>
              ) : (
                notifications.map((n) => (
                  <div
                    key={n.id}
                    style={{
                      padding: '10px 12px',
                      borderRadius: '8px',
                      marginBottom: '2px',
                      cursor: 'pointer',
                      transition: 'background 0.2s',
                      background: n.is_read ? 'transparent' : 'rgba(127,181,255,0.06)',
                    }}
                    onClick={() => {
                      if (!n.is_read) markAsRead(n.id);
                    }}
                  >
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                      <span style={{ fontSize: '16px', flexShrink: 0 }}>{typeIcon(n.type)}</span>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{
                          fontSize: '13px',
                          fontWeight: n.is_read ? 400 : 600,
                          color: n.is_read ? 'rgba(255,255,255,0.6)' : '#fff',
                          lineHeight: 1.4,
                        }}>
                          {n.title}
                        </div>
                        {n.content && (
                          <div style={{
                            fontSize: '12px',
                            color: 'rgba(255,255,255,0.4)',
                            marginTop: '2px',
                            lineHeight: 1.4,
                          }}>
                            {n.content}
                          </div>
                        )}
                        <div style={{
                          fontSize: '11px',
                          color: 'rgba(255,255,255,0.25)',
                          marginTop: '4px',
                        }}>
                          {new Date(n.created_at).toLocaleDateString('zh-CN', {
                            month: 'short',
                            day: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                          })}
                        </div>
                      </div>
                      {!n.is_read && (
                        <div style={{
                          width: '6px',
                          height: '6px',
                          borderRadius: '50%',
                          background: '#7fb5ff',
                          flexShrink: 0,
                          marginTop: '6px',
                        }} />
                      )}
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
